export const environment = {
  production: false,
  env:'Pruebas',
  ApiUrl: 'https://icamiapitest.clavisco.com/',
};
